import React from 'react';
import ScrollProgressRead from 'react-scroll-progress-read';
import { useTheme } from '../../contexts/ThemeContext';
import { ProgressBar } from './Style';

const Progress = (props) => {
    const { themeMode, theme } = useTheme();

    // Set colors based on theme mode
    const barColor =
        themeMode === 'light' ? theme.colors.primary || '#000' : '#FFF';
    const backgroundColor =
        themeMode === 'light'
            ? 'rgba(0, 0, 0, 0.15)'
            : 'rgba(255, 255, 255, 0.25)';

    return (
        <ProgressBar>
            <ScrollProgressRead
                barColor={barColor}
                backgroundColor={backgroundColor}
                height="5px"
            />
        </ProgressBar>
    );
};

export default Progress;
